import * as React from "react";

import classnames from "classnames";

type PropsType = React.PropsWithChildren & {};

export default function ContentWrapper(props: PropsType) {
  const classes = classnames("wib-content-wrapper", {
    "wib-drawer-menu-expanded": false
  });

  const style: React.CSSProperties = {
    overflowY: "auto"
  };

  return (
    <div style={style} className={classes}>
      {props.children}
    </div>
  );
}
